import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASSES = ["border-green-500", "text-green-600"]
const INACTIVE_CLASSES = [
  "border-transparent",
  "text-gray-500",
  "hover:text-gray-700",
  "hover:border-gray-300",
]

// Tab switcher for the export format panels (PDF / Mitarbeiter-PDF / Excel / CSV).
// Tabs and panels pair up by their data-tab value, so a new export format needs no
// change here — it only has to render a tab and a panel carrying the same value.
// Each panel's export-panel controller reports its column count; the matching tab
// chip shows it so every format's state is visible without switching tabs.
export default class extends Controller {
  static targets = ["tab", "panel", "count"]

  switchTab(event) {
    this.activate(event.currentTarget.dataset.tab)
  }

  activate(tab) {
    this.tabTargets.forEach((element) => {
      const isActive = element.dataset.tab === tab
      element.classList.remove(...(isActive ? INACTIVE_CLASSES : ACTIVE_CLASSES))
      element.classList.add(...(isActive ? ACTIVE_CLASSES : INACTIVE_CLASSES))
      element.setAttribute("aria-selected", isActive)
    })

    this.panelTargets.forEach((element) => {
      element.classList.toggle("hidden", element.dataset.tab !== tab)
    })
  }

  updateCount(event) {
    const { format, count } = event.detail
    const chip = this.countTargets.find((element) => element.dataset.tab === format)
    if (chip) chip.textContent = count
  }
}
